// extracted by mini-css-extract-plugin
module.exports =  {"root":"dNQnuFTMpvtlf4susYc7","dimensions":"JVSclx6lmp__yDYhHWes"};